/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react'
import Grid from '@material-ui/core/Grid'
import { withTranslation } from 'react-i18next';
import GeneralButton from "../components/Buttons";
import GeneralText from "../components/Fonts";

function Notfound(props) {
  return (
    <Grid container direction="row" className="container page-not-found">
      <GeneralText
        variant="h3"
        gutterBottom={true}
      >
        {props.t('Page not found')}
      </GeneralText>
      <p>{props.t('Please get in touch')}</p>
      <GeneralButton
        href='/contact'
        className="btn btn-light align-button">
        {props.t('Contact')}
      </GeneralButton>
    </Grid>
  )
}

export default React.memo(withTranslation('message')(Notfound));